
import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useSecurityLogging = () => {
  const logSecurityEvent = useCallback(async (
    eventType: string,
    severity: 'low' | 'medium' | 'high' | 'critical',
    eventData: Record<string, any> = {},
    riskScore: number = 0
  ) => {
    try {
      const { data, error } = await supabase.rpc('log_enhanced_security_event', {
        p_event_type: eventType,
        p_severity: severity,
        p_event_data: eventData,
        p_risk_score: riskScore
      });

      if (error) throw error;
      return data;
    } catch (error: any) {
      console.error('Error logging security event:', error);
    }
  }, []);

  const detectSuspiciousActivity = useCallback(async (
    userId: string,
    action: string,
    timeframeMinutes: number = 60
  ) => {
    try {
      const { data, error } = await supabase.rpc('detect_suspicious_activity', {
        p_user_id: userId,
        p_action: action,
        p_timeframe_minutes: timeframeMinutes
      });

      if (error) throw error;
      return data;
    } catch (error: any) {
      console.error('Error detecting suspicious activity:', error);
      return false;
    }
  }, []);

  return {
    logSecurityEvent,
    detectSuspiciousActivity,
  };
};
